import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SignupFlowPageRoutingModule } from './signup-flow-routing.module';

import { SignupFlowPage } from './signup-flow.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SignupFlowPageRoutingModule, ComponentsModule],
  declarations: [SignupFlowPage],
})
export class SignupFlowPageModule {}
